// client/src/routes/_auth/verify-email.$token.tsx — „Confirmarea adresei" · D-2759.
//
// The path is the server's, not this file's: `EmailVerificationMailer` composes
// `{origin}/verify-email/{token}` and, when the signup carried a return path, `?next=<path>`
// (D-2753). Every confirmation mail ever sent points at exactly that, so the spelling is fixed.
//
// Under the pathless `_auth` layout, which gives the centred card, the full logo and the footer —
// the frame for a page opened from a mail.
//
// Nobody is redirected AWAY from here, in either direction. An anonymous visitor is the ordinary
// case, because an unconfirmed account cannot sign in; a signed-in one is possible too — the link
// opened in a browser that holds somebody's session — and still confirms the address it names.
//
// It still has to BOOTSTRAP, for the reason `/invite/$token` does: opening a mailed link is a hard
// navigation, nothing has presented the refresh cookie yet, and the page offers „Continuați"
// rather than „Autentificați-vă" when a session exists. `ensureSession()` redirects nobody; it resolves the
// store to `anonymous` or `authenticated` once.

import { createFileRoute } from '@tanstack/react-router';

import { VerifyEmail, verifyEmailSearchSchema } from '@/features/auth/VerifyEmail';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/verify-email/$token')({
  validateSearch: verifyEmailSearchSchema,
  beforeLoad: async () => {
    await ensureSession();
  },
  component: VerifyEmailScreen,
});

function VerifyEmailScreen() {
  const { token } = Route.useParams();
  const search = Route.useSearch();
  return <VerifyEmail token={token} search={search} />;
}
